import React, { useEffect, useState } from "react"
import styles from "./apiIntegration.module.css"
import Button from "../../components/Form/Button"
import Table from "../../components/Table"
import FormGroup from "../../components/Form/FormGroup"
import BreakForm from "../../components/Form/BreakForm"
import FormGroupInline from "../../components/Form/FormGroupInline"
import api from '../../services/api'
import { toast } from 'react-toastify'
import ModalApiDomain from "../../components/Modal/ModalApiDomain"
import ModalApiForm from "../../components/Modal/ModalApiForm"
import { useData } from "../../contexts/dataContext"
import Loading from "../layouts/Loading"
import ModalDelete from './../../components/Modal/ModalDelete'
import { MdOutlineDeleteOutline } from "react-icons/md"
import { MdBlock, MdHistory, MdOpenInNew } from "react-icons/md"
import BackButton from "../../components/BackButton"
import { useParams } from "react-router-dom"
import Modal from "../../components/Modal"
import DatePicker from "../../components/Form/DatePicker"
import Select from "../../components/Form/Select"
import { getOptionByOptionList } from "../../utils/utils"
import ModalApiFormSubmissions from "../../components/Modal/ModalApiFormSubmissions"
import ModalConfirm from "../../components/Modal/ModalConfirm"

const headersDomains = [
    "#",
    "Identificação",
    "Domínio",
    "Formulários",
    "Último cadastro",
    "Status",
    "",
]

const headersForms = [
    "#",
    "Domínio",
    "Formulário",
    "URL",
    "Cadastros",
    "Aguardando",
    "Falhas",
    "Último Cadastro",
    "Status",
    "",
]

const formatDateTime = (date) => date ? new Date(date).toLocaleString("pt-BR") : "-"
const formatNumber = (value = 0) => Number(value || 0).toLocaleString("pt-BR")
const getFormDisplayName = form => form?.form_metadata?.name || form?.form_metadata?.id || form?.form_metadata?.page_title || "Formulário"

const FormStatus = ({ configured, pending, failed }) => {
    const status = !configured ? "pending_config" : (failed > 0 ? "failed" : (pending > 0 ? "attention" : "configured"))
    const label = !configured ? "Precisa configurar" : (failed > 0 ? "Com falhas" : (pending > 0 ? "Com pendências" : "Ativo"))
    return <span className={`${styles.formStatus} ${styles[status]}`}>{label}</span>
}

const DomainStatus = ({ domain }) => {
    const receiving = domain?.submissions_count > 0
    const label = !domain?.is_active ? "Bloqueado" : receiving ? "Recebendo" : "Aguardando teste"
    const status = !domain?.is_active ? "failed" : receiving ? "configured" : "attention"
    return <span className={`${styles.formStatus} ${styles[status]}`}>{label}</span>
}

const ApiForm = () => {
    const [domains, setDomains] = useState([])
    const [forms, setForms] = useState([])
    const [showModalDomain, setShowModalDomain] = useState(false)
    const [domain, setDomain] = useState({})
    const [editDomain, setEditDomain] = useState(false)
    const [isNewDomain, setIsNewDomain] = useState(false)
    const [showModalForm, setShowModalForm] = useState(false)
    const [showSubmissionsModal, setShowSubmissionsModal] = useState(false)
    const [submissionsForm, setSubmissionsForm] = useState({})
    const [form, setForm] = useState({})
    const [editForm, setEditForm] = useState(false)
    const [allFields, setAllFields] = useState([])
    const [showModalDelete, setShowModalDelete] = useState(false)
    const [showAssignmentHistoryModal, setShowAssignmentHistoryModal] = useState(false)
    const [assignmentHistoryForm, setAssignmentHistoryForm] = useState({})
    const [assignmentHistoryFilters, setAssignmentHistoryFilters] = useState({ dateStart: "", dateEnd: "", forms: [] })
    const [assignmentHistory, setAssignmentHistory] = useState({ assignments: [], pagination: {} })
    const [isLoadingAssignmentHistory, setIsLoadingAssignmentHistory] = useState(false)
    const [domainIdDelete, setDomainIdDelete] = useState()
    const [domainToToggle, setDomainToToggle] = useState(null)
    const [loading, setLoading] = useState(0)
    const { account_id } = useParams()

    const { funnels, teams, users, flags, fields } = useData()

    useEffect(() => {
        getAllDomains()
        getAllForms()
    }, [])

    useEffect(() => {
        setAllFields([{ id: -1, value: "Ignorar campo" }, ...fields])
    }, [fields])

    const getAllDomains = async () => {
        try {
            setLoading(previousValue => ++previousValue)
            const response = await api.get("/integrations/api/domains")
            const domains = response?.data?.data
            setDomains(domains)
        } catch (err) {
            toast.error(err?.response?.data?.message)
        } finally {
            setLoading(previousValue => Math.max(0, previousValue - 1))
        }
    }

    const getAllForms = async () => {
        try {
            setLoading(previousValue => ++previousValue)
            const response = await api.get("/integrations/api/forms")
            const forms = response?.data?.data
            setForms(forms)
        } catch (err) {
            toast.error(err?.response?.data?.message)
        } finally {
            setLoading(previousValue => Math.max(0, previousValue - 1))
        }
    }

    const getFilteredValuesDomains = () => {
        const values = [...domains]
        values.sort((a, b) => {
            if (a.name > b.name) {
                return 1
            } else if (a.name < b.name) {
                return - 1
            } else {
                return 0
            }
        })
        const filteredValues = values?.map((domain) => getDataNewDomains(domain))
        return filteredValues
    }

    const getDataNewDomains = (newDomain) => {
        const data = {
            id: newDomain._id,
            value: [
                newDomain.name,
                newDomain.domain,
                formatNumber(newDomain.forms_count),
                formatDateTime(newDomain.last_received_at),
                <DomainStatus domain={newDomain} />,
            ],
            actions: [
                {
                    label: "Ver instalação",
                    onClick: (id) => handleShowModalDomain(false, false, id)
                },
                {
                    label: "Editar",
                    onClick: (id) => handleShowModalDomain(false, true, id)
                },
                {
                    label: newDomain.is_active ? "Bloquear captura" : "Reativar captura",
                    onClick: () => setDomainToToggle(newDomain)
                },
                {
                    label: "Excluir",
                    onClick: handleOpenModalDelete
                }
            ]
        }
        return data
    }

    const getFilteredValuesForms = () => {
        const values = forms
        values.sort((a, b) => {
            if (a.domain > b.domain) {
                return 1
            } else if (a.domain < b.domain) {
                return - 1
            } else {
                return 0
            }
        })
        const filteredValues = values?.map((form) => getDataNewForms(form))
        return filteredValues
    }

    const getDataNewForms = (newForm) => {
        const data = {
            id: newForm._id,
            value: [
                newForm?.domain,
                getFormDisplayName(newForm),
                newForm?.url?.length > 60 ? `${newForm.url.substr(0, 60)}...` : newForm?.url?.substr(0, 60),
                newForm?.sends,
                newForm?.pending,
                newForm?.failed,
                newForm?.last_send,
                <FormStatus configured={newForm?.config_finish} pending={newForm?.pending} failed={newForm?.failed} />,
            ],
            actions: [
                {
                    label: "Ver cadastros",
                    onClick: handleShowSubmissions
                },
                {
                    label: "Configurar formulário",
                    onClick: handleShowModalForm
                },
                {
                    label: "Histórico de atribuição",
                    onClick: handleShowAssignmentHistory
                }
            ]
        }
        return data
    }

    const getAssignmentHistory = (filters = assignmentHistoryFilters, page = 1) => {
        setIsLoadingAssignmentHistory(true)
        api.get("/integrations/api/forms/assignment-history", {
            params: {
                source: "api_form",
                ...(filters.forms?.length ? { forms: filters.forms.join(",") } : {}),
                ...(filters.dateStart ? { dateStart: filters.dateStart } : {}),
                ...(filters.dateEnd ? { dateEnd: filters.dateEnd } : {}),
                page,
                limit: 50,
            }
        }).then(response => {
            const data = response?.data?.data || { assignments: [], pagination: {} }
            setAssignmentHistory(previousValue => ({
                assignments: page > 1 ? [...(previousValue?.assignments || []), ...(data.assignments || [])] : data.assignments || [],
                pagination: data.pagination || {}
            }))
        }).catch(err => toast.error(err?.response?.data?.message))
            .finally(() => setIsLoadingAssignmentHistory(false))
    }

    const handleShowAssignmentHistory = (form_id) => {
        const selectedForm = forms.find(form => form._id === form_id) || {}
        const filters = { dateStart: "", dateEnd: "", forms: form_id ? [form_id] : [] }
        setAssignmentHistoryForm(selectedForm)
        setAssignmentHistoryFilters(filters)
        setShowAssignmentHistoryModal(true)
        getAssignmentHistory(filters)
    }

    const handleCloseAssignmentHistory = () => {
        setShowAssignmentHistoryModal(false)
        setAssignmentHistoryForm({})
        setAssignmentHistory({ assignments: [], pagination: {} })
    }

    const handleAssignmentHistoryPeriodChange = (dateStart, dateEnd) => {
        setAssignmentHistoryFilters(previousValue => ({ ...previousValue, dateStart: dateStart || "", dateEnd: dateEnd || "" }))
    }

    const handleLoadMoreAssignmentHistory = () => {
        const nextPage = Number(assignmentHistory?.pagination?.page || 1) + 1
        getAssignmentHistory(assignmentHistoryFilters, nextPage)
    }

    const getAssignmentRuleLabel = (assignment) => {
        const rule = assignment?.assignment_rule
        if (rule?.users?.includes("auto") && rule?.round_robin?.mode === "custom") return "Rodízio personalizado"
        if (rule?.users?.includes("auto")) return "Rodízio automático"
        if (rule?.users?.length) return "Usuário(s)"
        return "Regra não registrada"
    }

    const getUsersLabel = (items = []) => {
        const names = items.map(user => user.name).filter(Boolean)
        return names.length ? names.join(", ") : "-"
    }

    const getFormOptions = () => forms.map(form => ({
        id: form._id,
        value: `${form.domain || "-"} - ${getFormDisplayName(form)} - ${form.url || "-"}`
    }))

    const handleShowModalDomain = async (isNew = false, edit = false, id = undefined) => {
        setEditDomain(edit)
        setIsNewDomain(isNew)
        setDomain({})
        if (!isNew && id) {
            await getDomainById(id)
        }
        setShowModalDomain(true)
    }

    const handleCloseModalDomain = () => {
        setShowModalDomain(false)
        setDomain({})
    }

    const handleSaveDomain = (e, isNew, data) => {
        e.preventDefault()
        if (isNew) {
            handleSaveNewDomain(data)
        } else {
            handleUpdateDomain(data)
        }
    }

    const handleSaveNewDomain = async (data) => {
        try {
            setLoading(previousValue => ++previousValue)
            const response = await api.post("/integrations/api/domains", data)
            const newDomain = response.data?.data
            if (newDomain) {
                setDomains(previousValue => {
                    const newValue = [...previousValue]
                    newValue.push(
                        newDomain
                    )

                    return newValue
                })
                setDomain(newDomain)
                setIsNewDomain(false)
                setEditDomain(false)
            }
            toast.success("Domínio conectado. Agora instale o script no site.")
        } catch (err) {
            toast.error(err?.response?.data?.message)
        } finally {
            setLoading(previousValue => Math.max(0, previousValue - 1))
        }
    }

    const handleUpdateDomain = async (data) => {
        try {
            setLoading(previousValue => ++previousValue)
            const response = await api.patch(`/integrations/api/domains/${data._id}`, data)
            const updatedDomain = { ...data, ...(response?.data?.data || {}) }
            setDomains(previousValue => {
                return previousValue?.map(el => {
                    if (el._id === data._id) {
                        el = { ...el, ...updatedDomain }
                    }
                    return el
                })
            })
            toast.success(response?.data?.message)
            handleCloseModalDomain()
        } catch (err) {
            toast.error(err?.response?.data?.message)
        } finally {
            setLoading(previousValue => Math.max(0, previousValue - 1))
        }
    }

    const handleOpenModalDelete = (domain_id) => {
        setDomainIdDelete(domain_id)
        setShowModalDelete(true)
    }

    const handleCloseModalDelete = () => {
        setDomainIdDelete()
        setShowModalDelete(false)
    }

    const handleDeleteDomain = async (domain_id) => {
        try {
            setLoading(previousValue => ++previousValue)
            const response = await api.delete(`/integrations/api/domains/${domain_id}`)
            setDomains(previousValue => previousValue?.filter(domain => domain._id !== domain_id))
            handleCloseModalDelete()
            toast.success(response?.data?.message)
        } catch (err) {
            toast.error(err?.response?.data?.message)
        } finally {
            setLoading(previousValue => Math.max(0, previousValue - 1))
        }

    }

    const getDomainById = async (domain_id) => {
        try {
            setLoading(previousValue => ++previousValue)
            const response = await api.get(`/integrations/api/domains/${domain_id}`)
            const domain = response.data?.data
            setDomain(domain)
        } catch (err) {
            toast.error(err?.response?.data?.message)
        } finally {
            setLoading(previousValue => Math.max(0, previousValue - 1))
        }
    }

    const handleShowModalForm = async (form_id) => {
        await getFormById(form_id)
        setShowModalForm(true)
    }

    const handleToggleDomain = async () => {
        if (!domainToToggle) return
        try {
            setLoading(previousValue => ++previousValue)
            const response = await api.patch(`/integrations/api/domains/${domainToToggle._id}`, {
                name: domainToToggle.name,
                is_active: !domainToToggle.is_active,
            })
            const updated = response?.data?.data || { ...domainToToggle, is_active: !domainToToggle.is_active }
            setDomains(previousValue => previousValue.map(item => item._id === updated._id ? { ...item, ...updated } : item))
            setDomainToToggle(null)
            toast.success(response?.data?.message)
        } catch (err) {
            toast.error(err?.response?.data?.message)
        } finally {
            setLoading(previousValue => Math.max(0, previousValue - 1))
        }
    }

    const handleShowSubmissions = (form_id) => {
        const selectedForm = forms.find(item => item._id === form_id) || {}
        setSubmissionsForm(selectedForm)
        setShowSubmissionsModal(true)
    }

    const handleCloseSubmissions = () => {
        setShowSubmissionsModal(false)
        setSubmissionsForm({})
    }

    const totalPendingSubmissions = forms.reduce((total, item) => total + Number(item.pending || 0), 0)
    const totalFailedSubmissions = forms.reduce((total, item) => total + Number(item.failed || 0), 0)
    const pendingForms = forms.filter(item => !item.config_finish).length
    const activeForms = forms.filter(item => item.config_finish).length

    const handleCloseModalForm = () => {
        setShowModalForm(false)
        setForm({})
    }

    const handleSaveForm = async (data) => {
        try {
            setLoading(previousValue => ++previousValue)
            const response = await api.patch(`/integrations/api/forms/${data._id}`, data)
            const newForm = response?.data?.data
            if (newForm) {
                setForms(previousValue => {
                    return previousValue?.map(el => {
                        if (el._id === newForm._id) {
                            el = newForm
                        }
                        return el
                    })
                })
            }
            toast.success(response?.data?.message)
            setEditForm(false)
        } catch (err) {
            toast.error(err?.response?.data?.message)
        } finally {
            setLoading(previousValue => Math.max(0, previousValue - 1))
        }
    }

    const getFormById = async (form_id) => {
        try {
            setLoading(previousValue => ++previousValue)
            const response = await api.get(`/integrations/api/forms/${form_id}`)
            const form = response.data?.data
            setForm(form)
        } catch (err) {
            toast.error(err?.response?.data?.message)
        } finally {
            setLoading(previousValue => Math.max(0, previousValue - 1))
        }
    }

    return (
        <>
            <div className={styles.container}>
                <div className="page-back-row">
                    <BackButton fallback={`/${account_id}/integrations`} />
                </div>
                <div className={styles.integrationSummary}>
                    <div><strong>{formatNumber(forms.length)}</strong><span>Formulários detectados</span></div>
                    <div className={pendingForms ? styles.summaryWarning : ""}><strong>{formatNumber(pendingForms)}</strong><span>Precisam configurar</span></div>
                    <div className={totalPendingSubmissions ? styles.summaryWarning : ""}><strong>{formatNumber(totalPendingSubmissions)}</strong><span>Cadastros aguardando</span></div>
                    <div className={totalFailedSubmissions ? styles.summaryDanger : ""}><strong>{formatNumber(totalFailedSubmissions)}</strong><span>Falhas de importação</span></div>
                    <div><strong>{formatNumber(activeForms)}</strong><span>Formulários ativos</span></div>
                </div>
                <FormGroup>
                    <FormGroupInline>
                        <div className={styles.header}>
                            <BreakForm title="Domínios Permitidos" showAction={false} />
                            <span>Essa é a lista de domínios que possuem permissão para enviar dados para seu CRM.</span>
                        </div>
                        <Button variant="primary" onClick={() => handleShowModalDomain(true, true)}>Conectar um novo domínio</Button>
                    </FormGroupInline>
                    <Table
                        headers={headersDomains}
                        values={getFilteredValuesDomains()}
                        messageNotRegisters="Nenhum registro encontrado"
                        onClick={(id) => handleShowModalDomain(false, false, id)}
                        showIndex={true}
                    />
                </FormGroup>
                <FormGroup>
                    <FormGroupInline>
                        <div className={styles.header}>
                            <BreakForm title="Lista de Formulários" showAction={false} />
                            <span>Confira os formulários detectados, seus cadastros e pendências. Clique sobre um item para ver os dados recebidos.</span>
                        </div>
                    </FormGroupInline>
                    <Table
                        headers={headersForms}
                        values={getFilteredValuesForms()}
                        messageNotRegisters="Nenhum registro encontrado"
                        onClick={handleShowSubmissions}
                        showIndex={true}
                    />
                </FormGroup>
            </div>
            {showModalDomain &&
                <ModalApiDomain
                    closeModal={handleCloseModalDomain}
                    onSubmit={handleSaveDomain}
                    isNew={isNewDomain}
                    setEdit={setEditDomain}
                    value={domain}
                    editable={editDomain}
                />
            }
            {showModalForm &&
                <ModalApiForm
                    closeModal={handleCloseModalForm}
                    onSubmit={handleSaveForm}
                    value={form}
                    funnels={funnels}
                    teams={teams}
                    users={users}
                    flags={flags}
                    fields={allFields}
                    editable={editForm}
                    setEdit={setEditForm}
                />
            }
            {showModalDelete &&
                <ModalDelete
                    closeModal={handleCloseModalDelete}
                    onSubmit={handleDeleteDomain}
                    icon={<MdOutlineDeleteOutline />}
                    title="Exclusão de domínio"
                    description="Deseja realmente excluir o domínio?"
                    id={domainIdDelete}
                />
            }
            {domainToToggle &&
                <ModalConfirm
                    closeModal={() => setDomainToToggle(null)}
                    onSubmit={handleToggleDomain}
                    icon={<MdBlock />}
                    title={domainToToggle.is_active ? "Bloquear captura" : "Reativar captura"}
                    description={domainToToggle.domain}
                    text={domainToToggle.is_active
                        ? "Novos cadastros deixarão de ser aceitos imediatamente. Os dados já recebidos permanecem disponíveis."
                        : "O script voltará a aceitar novos cadastros deste domínio."}
                    confirmLabel={domainToToggle.is_active ? "Bloquear captura" : "Reativar captura"}
                    confirmVariant={domainToToggle.is_active ? "danger" : "primary"}
                />
            }
            {showSubmissionsModal &&
                <ModalApiFormSubmissions form={submissionsForm} closeModal={handleCloseSubmissions} onChanged={getAllForms} />
            }
            {showAssignmentHistoryModal &&
                <Modal
                    icon={<MdHistory />}
                    title="Histórico de atribuição"
                    description={`Formulário ${assignmentHistoryForm?.url || ""}`}
                    closeModal={handleCloseAssignmentHistory}
                    fullWidith={true}
                    heightFitContent={true}
                >
                    <div className={styles.assignmentHistoryModal}>
                        <div className={styles.assignmentHistoryFilters}>
                            <DatePicker multiple={true} name="Período" dateStart={assignmentHistoryFilters.dateStart || ""} dateEnd={assignmentHistoryFilters.dateEnd || ""} onChange={handleAssignmentHistoryPeriodChange} />
                            <Select name="Formulários" placeholder="Todos os formulários" options={getFormOptions()} selected={assignmentHistoryFilters.forms || []} multiple={true} onChange={(forms) => setAssignmentHistoryFilters(previousValue => ({ ...previousValue, forms }))} />
                            <Button variant="secondary" onClick={() => getAssignmentHistory()}>Filtrar</Button>
                        </div>
                        <div className={styles.assignmentHistorySummary}>
                            <strong>{formatNumber(assignmentHistory?.pagination?.total || assignmentHistory?.assignments?.length || 0)}</strong>
                            <span>atribuições encontradas</span>
                        </div>
                        <div className={styles.assignmentHistoryTable}>
                            <div className={styles.assignmentHistoryHeader}>
                                <span>Data</span>
                                <span>Formulário</span>
                                <span>Lead</span>
                                <span>Atribuído para</span>
                                <span>Regra</span>
                                <span>Elegíveis</span>
                            </div>
                            {assignmentHistory?.assignments?.map(assignment => (
                                <div key={assignment._id} className={styles.assignmentHistoryRow}>
                                    <span>{formatDateTime(assignment.created_at)}</span>
                                    <span>{getOptionByOptionList(assignment.api_form_id, getFormOptions(), "id", "value") || "-"}</span>
                                    <span>
                                        {assignment?.lead?.url ?
                                            <a href={assignment.lead.url} target="_blank" rel="noreferrer">{assignment.lead.name} <MdOpenInNew /></a>
                                            : assignment?.lead?.name || "-"
                                        }
                                    </span>
                                    <strong>{getUsersLabel(assignment.assigned_users)}</strong>
                                    <span>{getAssignmentRuleLabel(assignment)}</span>
                                    <span>{getUsersLabel(assignment.eligible_users)}</span>
                                </div>
                            ))}
                            {!assignmentHistory?.assignments?.length && !isLoadingAssignmentHistory &&
                                <div className={styles.assignmentHistoryEmpty}>Nenhuma atribuição registrada nesse período.</div>
                            }
                            {isLoadingAssignmentHistory &&
                                <div className={styles.assignmentHistoryEmpty}>Carregando histórico...</div>
                            }
                        </div>
                        {assignmentHistory?.pagination?.has_more &&
                            <div className={styles.assignmentHistoryLoadMore}>
                                <Button variant="secondary" onClick={handleLoadMoreAssignmentHistory} disabled={isLoadingAssignmentHistory}>
                                    {isLoadingAssignmentHistory ? "Carregando..." : "Carregar mais"}
                                </Button>
                            </div>
                        }
                    </div>
                </Modal>
            }
            {loading > 0 && <Loading fullPage={true} />}
        </>
    )
}

export default ApiForm
